import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import EmailRouter from './EmailRouter'
import EmailSummary from './EmailSummary'
import EmailFullDefault from './EmailFull/Default'
import EmailFullVolny from './EmailFull/Volny'

class Email extends EmailRouter {
  constructor (props) {
    super(props)
    this.state = {
      inbox: {},
      isLoading: false
    }
  }

  componentDidMount () {
    this.props.container.subscribe(this)
  }

  render () {
    const {
      props: {
        widget,
        EmailFullComponent
      },
      state: {
        inbox,
        isLoading
      }
    } = this

    return (
      <div id={widget.name}>
        {this.isResponseFull(inbox) ? (
          <EmailFullComponent widget={widget} inbox={inbox}/>
        ) : (
          <EmailSummary widget={widget} inbox={inbox} loading={isLoading}/>
        )}
      </div>
    )
  }
}

Email.propTypes = {
  widget: PropTypes.object.isRequired,
  EmailFullComponent: PropTypes.func.isRequired,
  container: PropTypes.object.isRequired
}

class DefaultEmail extends PureComponent {
  render () {
    const {
      ...props
    } = this.props

    return (
      <Email {...props} EmailFullComponent={EmailFullDefault}/>
    )
  }
}

class VolnyEmail extends PureComponent {
  render () {
    const {
      ...props
    } = this.props

    return (
      <Email {...props} EmailFullComponent={EmailFullVolny}/>
    )
  }
}

export { DefaultEmail, VolnyEmail }
